// extracted by mini-css-extract-plugin
var _1 = "RightPanelContainer-module__animatedBackground--cNXCT";
var _2 = "RightPanelContainer-module__isOpen--KSbhP";
var _3 = "RightPanelContainer-module__rightPanelContainer--MqnFJ";
var _4 = "RightPanelContainer-module__shiftContent--eOQ8e";
var _5 = "RightPanelContainer-module__viewContainer--C9jIw";
export { _1 as "animatedBackground", _2 as "isOpen", _3 as "rightPanelContainer", _4 as "shiftContent", _5 as "viewContainer" }
